(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/empty-data-view/assets/javascripts/empty-data-view.js') >= 0) return;  svs.modules.push('/components/racing/empty-data-view/assets/javascripts/empty-data-view.js');
"use strict";


const Icon = svs.ui.ReactIcon;
const EmptyDataView = _ref => {
  let {
    label,
    isFadeIn
  } = _ref;
  return React.createElement("div", {
    className: "f-center empty-data-view".concat(isFadeIn ? ' animate animate-show animate-time-short animate-delay' : ''),
    "data-testid": "empty-data-view"
  }, React.createElement(Icon, {
    color: "fc-racing",
    icon: "rest",
    size: "900"
  }), React.createElement("p", {
    className: "empty-data-view-text"
  }, label ? label : 'Här är det tomt!'));
};
svs.racing.emptyDataView.EmptyDataView = EmptyDataView;

 })(window);